import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

function Header() {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMouseEnter = (dropdown) => {
    setActiveDropdown(dropdown);
  };

  const handleMouseLeave = () => {
    setActiveDropdown(null);
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setActiveDropdown(null);
  };

  return (
    <header className={`header ${isMenuOpen ? 'nav-open' : ''}`}>
      <div className="header-container">
        <Link to="/" className="header-logo" onClick={closeMenu}>EJ Business & Co</Link>
        <button
          type="button"
          className="hamburger"
          onClick={toggleMenu}
          aria-expanded={isMenuOpen}
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
        >
          <span className="hamburger-line" />
          <span className="hamburger-line" />
          <span className="hamburger-line" />
        </button>
        <nav className="header-nav">
          <div 
            className="nav-item"
            onMouseEnter={() => handleMouseEnter('home')}
            onMouseLeave={handleMouseLeave}
          >
            <Link to="/" className="nav-link" onClick={closeMenu}>Home</Link>
            {activeDropdown === 'home' && (
              <div 
                className="dropdown-menu"
                onMouseEnter={() => handleMouseEnter('home')}
                onMouseLeave={handleMouseLeave}
              >
                <Link to="/" className="dropdown-item" onClick={closeMenu}>Home Page</Link>
                <Link to="/" className="dropdown-item" onClick={closeMenu}>About Us</Link>
              </div>
            )}
          </div>
          
          <div 
            className="nav-item"
            onMouseEnter={() => handleMouseEnter('order')}
            onMouseLeave={handleMouseLeave}
          >
            <Link to="/order" className="nav-link" onClick={closeMenu}>Order</Link>
            {activeDropdown === 'order' && (
              <div 
                className="dropdown-menu"
                onMouseEnter={() => handleMouseEnter('order')}
                onMouseLeave={handleMouseLeave}
              >
                <Link to="/order" className="dropdown-item" onClick={closeMenu}>Request 3D Print</Link>
              </div>
            )}
          </div>
          
          <div 
            className="nav-item"
            onMouseEnter={() => handleMouseEnter('contact')}
            onMouseLeave={handleMouseLeave}
          >
            <Link to="/contact" className="nav-link" onClick={closeMenu}>Contact</Link>
            {activeDropdown === 'contact' && (
              <div 
                className="dropdown-menu"
                onMouseEnter={() => handleMouseEnter('contact')}
                onMouseLeave={handleMouseLeave}
              >
                <Link to="/contact" className="dropdown-item" onClick={closeMenu}>Contact Us</Link>
              </div>
            )}
          </div>
        </nav>
      </div>
    </header>
  );
}

export default Header;
